module.exports = __webpack_public_path__ + "img/brand6.65517a8e.png";